/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_First_TimeInputs */

const en_us2_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`first time`)
};

const pt_br2_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`primeira vez`)
};

const es_419_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`primera vez`)
};

const pt_pt2_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`primeira vez`)
};

const fr_fr2_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`première fois`)
};

const de_de2_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zum ersten Mal`)
};

const it_it2_workout_first_time = /** @type {(inputs: Workout_First_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prima volta`)
};

/**
* | output |
* | --- |
* | "first time" |
*
* @param {Workout_First_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_first_time = /** @type {((inputs?: Workout_First_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_First_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_first_time(inputs)
	if (locale === "es-419") return es_419_workout_first_time(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_first_time(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_first_time(inputs)
	if (locale === "de-DE") return de_de2_workout_first_time(inputs)
	if (locale === "it-IT") return it_it2_workout_first_time(inputs)
	return en_us2_workout_first_time(inputs)
});
export { workout_first_time as "workout.first_time" }